// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const AwsWindowsInstancesIcon = createSvgIcon(
  <svg width={40} height={40} fill="none" viewBox="0 0 40 40">
    <path fill="url(#aws-windows-instances_svga)" d="M40 0H0v40h40z" />
    <path
      fill="#fff"
      d="M6 6h13.27v13.27H6zm14.73 0H34v13.27H20.73zM6 20.73h13.27V34H6zm14.73 0H34V34H20.73"
    />
    <defs>
      <linearGradient
        id="aws-windows-instances_svga"
        x1={0}
        x2={40.99}
        y1={0}
        y2={38.96}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
    </defs>
  </svg>,
  "AwsWindowsInstances",
);
export default AwsWindowsInstancesIcon;
